/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  BuilderUserContext,
  FormRootSchema,
  FormStateSchema,
} from '@gh/builder-shared';
import {
  DateTimeTypes,
  FormState,
  IS_REGION_AU_OR_NZ,
  NumberTypes,
} from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { JobBilling } from '../../../resources/cm.model';

@Injectable()
export class JobDetailsDatesTabFormState extends FormState<any> {

  constructor(
    private schemaFactory: BuilderFormSchemaFactory,
    private userContext: BuilderUserContext,
  ) {
    super(schemaFactory);
  }

  isCheckedConfirmedNotSlab(billing: JobBilling, field: boolean): boolean {
    if (field) {
      return true;
    } else {
      if (billing.isNotProceeding && !billing.isDpp && billing.reportedSlabDate !== null) {
        return true;
      } else {
        return false;
      }
    }
  }

  protected buildSchema(billing: JobBilling, { root, group }: FormStateSchema): FormRootSchema {
    const mode = FormMode.EditMode;
    return root({
      mode,
      children: {
        contactName: void 0,
        jobId:       void 0,
        jobNumber:   void 0,
        officeId:    void 0,

        amount:                      {
          enabled: false,
          type:    NumberTypes.SignedPrice,
        },
        amountWithGst:               {
          enabled: false,
          type:    NumberTypes.SignedPrice,
          visible: IS_REGION_AU_OR_NZ,
        },
        franchiseeFee:               {
          enabled: false,
          type:    NumberTypes.Percents,
        },
        masterFee:                   {
          enabled: false,
          type:    NumberTypes.Percents,
          visible: [this.userContext.corporateView, IS_REGION_AU_OR_NZ],
        },
        variationsAmount:            {
          enabled: false,
          type:    NumberTypes.SignedPrice,
        },
        variationsAmountWithGst:     {
          enabled: false,
          type:    NumberTypes.SignedPrice,
          visible: IS_REGION_AU_OR_NZ,
        },
        franchiseeVariationFee:      {
          enabled: false,
          type:    NumberTypes.Percents,
        },
        masterVariationFee:          {
          enabled: false,
          type:    NumberTypes.Percents,
          visible: [this.userContext.corporateView, IS_REGION_AU_OR_NZ],
        },
        totalOfficeFee:              {
          enabled: false,
          type:    NumberTypes.Percents,
        },
        totalOfficeVariationFee:     {
          enabled: false,
          type:    NumberTypes.Percents,
        },
        officePaymentDue:            {
          enabled: false,
          type:    NumberTypes.SignedPrice,
        },
        paid:                        void 0,
        officePaidAmount:            {
          type: NumberTypes.SignedPrice,
        },
        officePaidToDate:            {
          enabled: false,
          type:    NumberTypes.SignedPrice,
        },
        officeLastPaymentDate:       {
          type: DateTimeTypes.ShortDate,
        },
        totalMasterFee:              {
          enabled: false,
          type:    NumberTypes.Percents,
          visible: [this.userContext.corporateView, IS_REGION_AU_OR_NZ] ,
        },
        totalMasterVariationFee:     {
          enabled: false,
          type:    NumberTypes.Percents,
          visible: [this.userContext.corporateView, IS_REGION_AU_OR_NZ] ,
        },
        masterPaymentDue:            {
          enabled: false,
          type:    NumberTypes.SignedPrice,
          visible: [this.userContext.corporateView, IS_REGION_AU_OR_NZ],
        },
        paidMast:                    {
          visible: [this.userContext.corporateView, IS_REGION_AU_OR_NZ],
        },
        masterPaidAmount:            {
          type:    NumberTypes.SignedPrice,
          visible: [this.userContext.corporateView, IS_REGION_AU_OR_NZ],
        },
        masterPaidToDate:            {
          enabled: false,
          type:    NumberTypes.SignedPrice,
          visible: [this.userContext.corporateView, IS_REGION_AU_OR_NZ],
        },
        masterLastPaymentDate:       {
          type:    DateTimeTypes.ShortDate,
          visible: [this.userContext.corporateView, IS_REGION_AU_OR_NZ],
        },
        isMasterConfirmedNotSlab:    {
          enabled: this.isCheckedConfirmedNotSlab(billing, billing.isMasterConfirmedNotSlab),
          visible: [IS_REGION_AU_OR_NZ],
        },
        isCorporateConfirmedNotSlab: {
          visible: this.userContext.corporateView,
          enabled: this.isCheckedConfirmedNotSlab(billing, billing.isCorporateConfirmedNotSlab),
        },
        saleDate:                    {
          enabled: false,
          type:    DateTimeTypes.ShortDate,
        },
        reportedSaleDate:            {
          enabled: false,
          type:    DateTimeTypes.ShortDate,
        },
        slabDate:                    {
          enabled: false,
          type:    DateTimeTypes.ShortDate,
        },
        reportedSlabDate:            {
          enabled: false,
          type:    DateTimeTypes.ShortDate,
        },
        comments:                    void 0,
        items: void 0,
        unitsCount: { enabled: false },
      },
    });

  }
}
